import React from "react";
import { Table } from "@redriver/cinnamon";
import { withPermissions } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import RemoveReturnOnInvestmentModal from "./RemoveReturnOnInvestmentModal";
import EditReturnOnInvestmentModal from "./EditReturnOnInvestmentModal";

const ReturnOnInvestmentActions = ({
  returnOnInvestment,
  onRefresh,
  deleteAction,
  editAction,
  hasPermission,
  dealerOfficeId,
}) => {
  const canDelete = hasPermission(Targets.ReturnOnInvestment, Actions.Delete);
  const canEdit = hasPermission(Targets.ReturnOnInvestment, Actions.Edit);

  if (!canDelete && !canEdit) return null;

  return (
    <Table.Menu>
      {canEdit && (
        <EditReturnOnInvestmentModal
          returnOnInvestmentId={returnOnInvestment.id}
          onSubmitted={onRefresh}
          submitAction={editAction}
          dealerOfficeId={dealerOfficeId}
        />
      )}
      {canDelete && (
        <RemoveReturnOnInvestmentModal
          returnOnInvestment={returnOnInvestment}
          onSubmitted={onRefresh}
          submitAction={deleteAction}
        />
      )}
    </Table.Menu>
  );
};

export default withPermissions(ReturnOnInvestmentActions);
